import { render, staticRenderFns } from "./Rgf.vue?vue&type=template&id=7bcf82c0&scoped=true"
import script from "./Rgf.vue?vue&type=script&lang=js"
export * from "./Rgf.vue?vue&type=script&lang=js"
import style0 from "./Rgf.vue?vue&type=style&index=0&id=7bcf82c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcf82c0",
  null
  
)

export default component.exports